export default {
  setProjectData (state, project) {
    if (project.hasOwnProperty('id')) state.id = project.id
    if (project.hasOwnProperty('customer_id')) state.customer_id = project.customer_id
    if (project.hasOwnProperty('name')) state.name = project.name
    if (project.hasOwnProperty('tag_line')) state.tag_line = project.tag_line
    if (project.hasOwnProperty('project_description')) state.project_description = project.project_description
    if (project.hasOwnProperty('order')) state.order = project.order
    if (project.hasOwnProperty('has_filters')) state.has_filters = project.has_filters
    if (project.hasOwnProperty('has_time_frame')) state.has_time_frame = project.has_time_frame
    if (project.hasOwnProperty('published')) state.published = project.published
    if (project.hasOwnProperty('type')) state.type = project.type
    if (project.hasOwnProperty('type_id')) state.type_id = project.type_id
    if (project.hasOwnProperty('maintenance_mode')) state.maintenance_mode = project.maintenance_mode
    if (project.hasOwnProperty('preview_image')) state.preview_image = project.preview_image
    if (project.hasOwnProperty('icon')) state.icon = project.icon
  },
  setPreviewImage (state, image) {
    state.preview_image = image
  },
  clear (state) {
    state.id = null
    state.customer_id = null
    state.name = ''
    state.tag_line = ''
    state.project_description = ''
    state.order = null
    state.has_filters = null
    state.has_time_frame = null
    state.published = null
    state.type = ''
    state.type_id = null
    state.maintenance_mode = false
    state.preview_image = null
    state.icon = null
  }
}
